import React, { useCallback, useMemo, useState } from 'react';
import { Dropdown } from '@epam/uui';
import { offset } from '@floating-ui/react';
import css from '../CardFilters/CardFilters.module.scss';
import { LinkButton } from '@epam/promo';
import { ReactComponent as IconFilter } from '@epam/assets/icons/common/content-filtration-18.svg';
import { DropdownFilterProps } from './FilterDropdown.model';
import renderBody from './renderBody';

const FilterDropdown = <TFilter = Record<string, string | string[]>,>({
  filter,
  setFilter,
  filterSettings,
}: DropdownFilterProps<TFilter>) => {
  const [newFilter, setNewFilter] = useState(filter ?? ({} as TFilter));

  const applyFilter = useCallback(() => {
    setFilter(newFilter);
  }, [newFilter, setFilter]);

  const resetFilter = useCallback(() => {
    setNewFilter(filter ?? ({} as TFilter));
  }, [filter, setNewFilter]);

  const updateFilter = useCallback(
    (filter: Partial<TFilter>) => {
      setNewFilter((prevData) => ({ ...prevData, ...filter }));
    },
    [setNewFilter],
  );

  const isSomeFilterActive = useMemo(() => {
    if (!filter) return false;

    return Object.values(filter).some(
      (i) => !!(i as string | string[] | undefined)?.length,
    );
  }, [filter]);

  return (
    <Dropdown
      closeOnClickOutside={true}
      closeOnEscape={true}
      closeOnTargetClick={true}
      middleware={[offset(6)]}
      renderBody={(props) =>
        renderBody({
          ...props,
          filter: newFilter,
          settings: filterSettings,
          updateFilter,
          resetFilter,
          applyFilter,
        })
      }
      renderTarget={(togglerProps) => (
        <LinkButton
          color={isSomeFilterActive ? 'blue' : 'gray60'}
          cx={css['taskInput__filter-icon']}
          icon={IconFilter}
          {...togglerProps}
        />
      )}
    />
  );
};

export default FilterDropdown;
